// extracted by mini-css-extract-plugin
export var notificationHost = "_i9-0";